module.exports = __webpack_public_path__ + "fonts/Montserrat-Bold.a361f0cc.eot";